import type { ReactElement } from 'react';
import styled from 'styled-components';

interface Props {
  /** Whether the toggle is on. */
  on: boolean;
  /** Invoked when the user flips it. */
  onChange: () => void;
  className?: string;
  /** Accessible name, for when the visible text sits outside the switch. */
  label?: string;
}

const Switch = styled.button<{ $on: boolean }>`
  position: relative;
  width: 38px;
  height: 22px;
  border-radius: 99px;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: background 0.15s;
  background: ${({ $on }): string => ($on ? 'rgb(78, 95, 253)' : 'rgba(255, 255, 255, 0.16)')};

  span {
    position: absolute;
    top: 3px;
    left: ${({ $on }): string => ($on ? '19px' : '3px')};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: rgb(255, 255, 255);
    transition: left 0.15s;
    box-shadow: rgba(0, 0, 0, 0.45) 0px 1px 3px;
  }
`;

/* Small pill toggle with a sliding knob. */
export const Toggle = ({ on, onChange, className, label }: Props): ReactElement => (
  <Switch
    type='button'
    $on={on}
    className={className}
    onClick={onChange}
    aria-pressed={on}
    aria-label={label}
  >
    <span />
  </Switch>
);
